import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PART_FINDER_FEEDBACK_QUERY_KEY } from './usePartFinderFeedback';

export const useClearPartFinderFeedback = (reportId: string) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useMutation<void, AxiosApiError, string>({
    mutationFn: async targetId => {
      await api.tenants.clearPartFinderFeedback(tenantId, reportId, targetId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PART_FINDER_FEEDBACK_QUERY_KEY, reportId] });
    },
  });
};
